import { lazy } from "react"

const PlayerPage$$__react__lazy__component = lazy(() => 
    import("./PlayerPage__original__module.mjs")
        .then(module => module.get_$$PlayerPage$$PlayerPage$$react__component$$1tzr5eeofsx2a())
        .then(component => ({ default: component }))
)

export const get_$$PlayerPage$$PlayerPage$$react__component$$1tzr5eeofsx2a = () => PlayerPage$$__react__lazy__component